<template>
  <div id="wrap">
    <div class="first" v-for="(item, key) in navLists" :key="key">
      <li>
        <span :index="item.key" v-if="!item.child"><a :href="item.path">{{ item.title }}</a> </span>
        <span @click="handleClick(key)" v-else> {{ item.title }}</span>
        <div
            v-for="(item2, key2) in item.child"
            :key="key2"
            class="second"
            v-show="show2 && currIndex == key">
          <p @click="secondClick(key2)"><a :href="item2.path">{{ item2.subTitle }}</a></p>
          <div
              v-for="(item3, key3) in item2.threeChild"
              :key="key3"
              class="three"
              v-show="show3 && currIndex2 == key2">
            <a :href="item3.path"> {{ item3.threeTitle }}</a>
          </div>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComMeum",
  components: {},
  data() {
    return {
      i: 0,
      show3: false,
      show2: false,
      navLists: [
        {
          title: "首页",
          path: "/"
        },
        {
          title: "学校概况",
          path: "/schoolProfile"
        },
        {
          title: "人才培养",
          child: [
            {
              subTitle: "本科教育",
              path: "/collegePage"
            },
            {
              subTitle: "硕士教育",
              esubTitle: "#projectIntroduction",
              threeChild: [
                {threeTitle: "工商管理硕士", path: "/eduMba"},
                // {threeTitle: "工商管理硕士(精益管理方向)", path: "/eduMbaLean"},
                // {threeTitle: "人工智能应用与管理硕士", path: "/eduMbaAi"},
                {threeTitle: "市场营销与经营管理硕士", path: "/eduScyx"},
                {threeTitle: "教育管理硕士", path: "/eduData"},
                {threeTitle: "国际商务管理硕士", path: "/eduDzsw"},
                {threeTitle: "应用心理学与管理硕士", path: "/eduApply"},
                {threeTitle: "资产管理与金融硕士", path: "/eduFinance"},
                {threeTitle: "房地产经济与管理硕士", path: "/eduGjsw"},
                {threeTitle: "数字化经营与管理硕士", path: "/eduManger"},
                {threeTitle: "会计与管理硕士", path: "/masterAccount"},
                {threeTitle: "健康管理硕士", path: "/healthMba"},
                // {threeTitle: "艺术设计与管理硕士", path: "/madmVue"},
              ],
            },
            {
              subTitle: "博士教育",
              threeChild: [
                {threeTitle: "工商管理博士", path: "/eduDba"},
                {threeTitle: "工商管理博士(online)", path: "/eduDbaOnline"},
                {threeTitle: "工商管理博士(精益管理方向)", path: "/eduDbaLean"},
                {threeTitle: "应用心理学与管理博士", path: "/eduYyxlBs"},
                {threeTitle: "健康心理博士", path: "/healthDba"},
                // {threeTitle: "人工智能应用与管理博士", path: "/eduDarm"},
              ],
            },
            // {
            //   subTitle: "终身教育",
            //   threeChild: [
            //     {threeTitle: "心理咨询师", path: "/entrepreneursPage"},
            //     {threeTitle: "家庭研修班", path: "/lifePage"},
            //   ],
            // }, {
            //   subTitle: "高端培训与咨询",
            //   threeChild: [
            //     {threeTitle: "智点研究院", path: "/hignEduPage"},
            //     {threeTitle: "卓越企业家", path: "/psychologyPage"},
            //   ],
            // },
          ],
        },
        {
          title: "师资队伍",
          path: "/teacherTroop"
        },
        {
          title: "新闻资讯",
          path: "/NewsList"
        },
        {
          title: "校友风采",
          path: "/alumniStyle"
        },
        {
          title: "招生报名",
          path: "http://wps.hainayx.com/index?channelCode=1-weixin-211"
        },
        {
          title: "招生就业",
          child: [
            {
              subTitle: "直营中心",
              path: "/centerPage"
            },
            {
              subTitle: "授权合作",
              path: "/agentPage"
            },
            {
              subTitle: "合作咨询",
              path: "/consultPage"
            },
            {
              subTitle: "企业招聘",
              path: "/recruitmentPage"
            }
            // {
            //   subTitle: "合作项目",
            //   threeChild: [
            //     {threeTitle: "高端养康运营", path: "/healthPage"},
            //     {threeTitle: "食品营养学", path: "/foodPage"},
            //   ],
            // },
          ],
        },
        {
          title: "校友会",
          path: "/schoolAlumni"
        },
        {
          title: "实践与创新",
          child: [
            {
              subTitle: "私董会",
              path: "/innovation?type=1"
            },
            {
              subTitle: "企业管理研究会",
              path: "/innovation?type=2"
            },
            {
              subTitle: "3A精益管理学院",
              path: "/innovation?type=3"
            },
            {
              subTitle: "BBS·AI智创研究院",
              path: "/innovation?type=4"
            }
            // {
            //   subTitle: "合作项目",
            //   threeChild: [
            //     {threeTitle: "高端养康运营", path: "/healthPage"},
            //     {threeTitle: "食品营养学", path: "/foodPage"},
            //   ],
            // },
          ],
        },
      ],

      currIndex: "", //当前索引
      spanIndex: [], //索引数组
      arrIndex: "", //用于判断是否做索引数组找到当前索引。-1为找不到,0找到了。

      currIndex2: "", //二级导航当前索引
      spanIndex2: [], //索引数组
      arrIndex2: "", //用于判断是否做索引数组找到当前索引。-1为找不到,0找到了。
    };
  },
  methods: {
    handleClick(index) {
      // 初始化三级导航，默认不显示。
      this.show3 = false;
      this.spanIndex2.splice(-1, 1);
      // 当前索引=index
      this.currIndex = index;
      console.log("当前索引index", index);
      // 判断当前索引是否在索引数组spanIndex中。arrIndex的值只有两种结果，-1未找到。0找到了。
      this.arrIndex = this.spanIndex.indexOf(index);
      if (this.arrIndex == 0) {
        //arrIndex ==0，找到索引了，在索引数组spanIndex删除该索引,隐藏二级导航。
        this.spanIndex.splice(this.arrIndex, 1);
        this.show2 = false;
      } else {
        // arrIndex ==-1,没有找到，splice(-1,1)从spanIndex数组结尾处删除1个值，并将当前索引添加到索引数组spanIndex，show2为true，展示二级导航，
        this.spanIndex.splice(this.arrIndex, 1);
        this.spanIndex.push(index);
        this.show2 = true;
      }
    },

    secondClick(index) {
      console.log(index);
      // 当前索引=index
      this.currIndex2 = index;
      // 判断当前索引是否在索引数组spanIndex中。arrIndex的值只有两种结果，-1未找到。0找到了。
      this.arrIndex2 = this.spanIndex2.indexOf(index);
      console.log("arrIndex2", this.arrIndex2);

      if (this.arrIndex2 == 0) {
        //arrIndex ==0，找到索引了，在索引数组spanIndex删除该索引,隐藏二级导航。
        this.spanIndex2.splice(this.arrIndex2, 1);
        this.show3 = false;
      } else {
        // arrIndex ==-1,没有找到，splice(-1,1)从spanIndex数组结尾处删除1个值，并将当前索引添加到索引数组spanIndex，show2为true，展示二级导航，
        this.spanIndex2.splice(this.arrIndex2, 1);
        this.spanIndex2.push(index);
        this.show3 = true;
      }
      console.log("索引数组2", this.spanIndex2);
    },
  },
};
</script>

<style>
#wrap li {
  list-style: none;
}

#wrap li {
  font-size: 32px;
  color: #fff;
  margin-left: 30px;
}

#wrap li a {
  color: #fff;
}

.first {
  font-size: 24px;
  font-weight: bold;
}

.first:hover {
  cursor: pointer;
}

.second {
  font-size: 30px;
  font-weight: normal;
  margin-left: 50px;
  width: 60%;
}

.three {
  margin-left: 40px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/comMeum.vue